const getDealType = (leasingCalculatorEnabled, checkoutProcessEnabled) => {
  if (leasingCalculatorEnabled && checkoutProcessEnabled) {
    return "BTO";
  }

  if (checkoutProcessEnabled) {
    return "Checkout";
  }

  return "Classic";
};

export default getDealType;
